import { useQuery } from '@tanstack/react-query';
import { useFS } from '@/hooks/useFS';
import { detectProjectType, type ProjectType } from '@/lib/projectType';

/**
 * Hook to detect the type of a project based on its dependencies
 * @param projectId - The project ID to check
 * @returns Query result with the detected project type
 */
export function useProjectType(projectId: string | undefined) {
  const { fs } = useFS();

  return useQuery({
    queryKey: ['project-type', projectId],
    queryFn: async (): Promise<ProjectType> => {
      if (!projectId) return 'unknown';
      const projectPath = `/projects/${projectId}`;
      return detectProjectType(fs, projectPath);
    },
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
